import { Component, OnInit, Inject } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from "rxjs/observable/forkJoin";
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { GenericIdName } from '../../../shared/models/common-search-filters.model';
import { CommonFiltersService } from '../../../shared/services/common-search-filters.service';
import { ActionRecommendationService } from '../action-recommendations.service';
import { ActionRecommendationsViewModel } from '../action-recommendations.model';
import { ActionRecommendationRuleDetailComponent } from '../action-recommendation-rule-detail/action-recommendation-rule-detail.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'action-recommendation-rule',
  templateUrl: './action-recommendation-rule.component.html',
  styleUrls: ['./action-recommendation-rule.component.scss']
})
export class ActionRecommendationRuleComponent implements OnInit {
  
  // Drop-down lists
  customers: GenericIdName[] = [];
  jobsites: GenericIdName[] = [];
  models: GenericIdName[] = [];

  //Search Filters
  selectedCustomer: number;
  selectedJobsite: number;
  selectedModel: number;

  inspectionId: number;
  quoteId: number;
  componentId: number;

  displayedColumns: string[] = [ 'Model','Customer', 'Jobsite',  'RuleName', 'RuleDesc', 'Components', 'CreatedUser', 'Date'];

  dataSource = new MatTableDataSource();
  //comment:string;
  //labourCost = 0;
  //partsCost = 0;
  //miscCost = 0;
  //smuToTakeAction :number
  //smuToCompleteActionBy:number=0;

  form: FormGroup;
  savingForm = false;
  loading = false;

  constructor(private _dialogRef: MatDialogRef<ActionRecommendationRuleComponent>,
    private _CommonFiltersService: CommonFiltersService,
    private _RuleService: ActionRecommendationService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _notify: NotificationsService,
  private _fb: FormBuilder) { }

  ngOnInit() {
    this.inspectionId = this._data.inspectionId;
    this.quoteId = this._data.quoteId;
    this.componentId = this._data.componentId;
    this.loadModels();
    this.loadCustomers();
this.ResetFields();
    //T-7691
    // if (this.inspectionId > 0) {
    //   this.getDDLDataForInspection();
    // }
    //this.inspectionId = this._data.inspectionId;
    //this.quoteId = this._data.quoteId;
    //this.componentId = this._data.componentId;
    //if (this._data.inspectionSMU !== undefined) {
    //  this.smuToTakeAction = this._data.inspectionSMU;
    //}
    //this.getPossibleRecommendations();
    //this.form = this._fb.group({
    //  'recommendation': [0, Validators.required],
    //  'smuToTakeAction': [this.smuToTakeAction, Validators.required],
    //  'smuToCompleteActionBy': [this.smuToCompleteActionBy, Validators.required],
    //  'labourCost': [this.labourCost, Validators.required],
    //  'partsCost': [this.partsCost, Validators.required],
    //  'miscCost': [this.miscCost, Validators.required],
    //  'comment': ''
    //});
  }

  closeModal() {
    this._dialogRef.close();
  }

  loadCustomers() {
    this.customers = null
    this._CommonFiltersService.getCustomerList().subscribe(r => {
      if (r) {
        this.customers = r;
      }
    });
  }

  loadJobSites() {
    if (this.selectedCustomer == null)
      return;
    this.jobsites = null
    this._CommonFiltersService.getJobsiteList(this.selectedCustomer).subscribe(r => {
      if (r) {
        this.jobsites = r;
      }
    });
  }

  loadModels() {
    this.models = null
    this._CommonFiltersService.getModelList().subscribe(r => {
      if (r) {
        this.models = r;
      }
    });
  }

  getDDLDataForInspection() {
    this.loading = true;
    this._RuleService.GetCustomerJobSiteModelForInspection(this.inspectionId).subscribe(rec => {
      this.selectedCustomer = rec.CustomerId;
      this.selectedJobsite = rec.JobSiteId;
      this.selectedModel = rec.ModelId;
      this.loadCustomers();
      this.loadJobSites();
      this.loadModels();
      this.getRules();
      this.loading = false;
    }, err => {
      this._notify.error('Error', 'Unable to load Inspection. Please contact TrackTreads support. ');
      console.error(err);
      this.loading = false;
    });
  }

  getRules() {
    this.loading = true;
    this._RuleService.GetActionRecommendationRules(0, this.selectedCustomer, this.selectedJobsite, this.selectedModel).subscribe(rec => {
      this.dataSource.data = rec;
      console.log("Rec_____",rec);
      this.loading = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
      this.loading = false;
    });
  }

  ResetFields() {
    this.loading = true;
    this.selectedCustomer =0;
    this.selectedJobsite = 0;
    this.selectedModel = 0;
    this.customers = null;
    this.jobsites = null;
    this.models = null;
    this.dataSource.data = null;
    this.loadCustomers();
    this.loadModels();
    this.loading = false;
  }

  openAddRecommendationDetails(RuleId) {
    const addRecommendationModalRef = this._dialog.open(ActionRecommendationRuleDetailComponent, {
      data: {
        RuleId: RuleId,
        inspectionId: this.inspectionId
      }
    });
  }
  // openAddRecommendation(componentId: number) {
  //   const addRecommendationModalRef = this._dialog.open(ActionRecommendationRuleComponent, {
  //     data: {
  //       inspectionId: this.inspectionId,
  //       componentId: componentId,
  //       quoteId: this.selectedQuoteId,
  //       inspectionSMU: this.InspectionSMU,
  //     }
  //   });
  //   addRecommendationModalRef.afterClosed().subscribe(details => {
  //     if (details != null) {
  //       this._quotes.reloadQuoteOverview(this.inspectionId);
  //       this.loadSystem();
  //       this.reloadSelectedQuote.emit(details)
  //     }
  //   });
  // }
}
